import { useState, useEffect, useCallback } from 'react'
import { useFinances } from 'hooks/useFinances'
import { useIntake } from 'hooks/useIntakeContext'
import { selectData } from 'layouts/onboarding'
import { BalanceSheetRow } from 'layouts/authenticated/pages/dashboard/components/BalanceSheet/BalanceSheetRow'
import { BalanceSheetModalForm } from 'layouts/authenticated/pages/dashboard/components/BalanceSheetModalForm'
import styled from 'styled-components'
import Grid from '@mui/material/Grid'
import { BalanceSheetOnPageForm } from 'layouts/authenticated/pages/dashboard/components/BalanceSheetOnPageForm'
import { Box, Typography } from '@mui/material'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

export const TspLoansStep = () => {
  const { deductionTypes } = selectData
  const { getAccounts, createOrUpdateAccount, deleteAccount } = useFinances()
  const { intakeState, updateIntakeStateAtKey } = useIntake()
  const [tspLoans, setTspLoans] = useState()
  const [id, setId] = useState()
  const [version, setVersion] = useState()
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('liability')
  const [name, setName] = useState()
  const [subType, setSubType] = useState('tspLoan')
  const [sortKey, setSortKey] = useState()
  const [amount, setAmount] = useState()
  const [monthlyPayment, setMonthlyPayment] = useState()
  const [loanEndDate, setLoanEndDate] = useState()
  const [subTypeClassification, setSubTypeClassification] = useState()
  const [interestRate, setInterestRate] = useState()
  const [modalTitle, setModalTitle] = useState()
  const [tspLoanToSubmit, setTspLoanToSubmit] = useState(
    intakeState?.tspLoanToSubmit || {}
  )

  const storeTspLoans = useCallback(async () => {
    const accounts = await getAccounts()
    setTspLoans((accounts || []).filter(({ subType }) => subType === 'tspLoan'))
    setTspLoanToSubmit({
      name: 'TSP Loan',
      amount: 0,
      type: 'liability',
      subType: 'tspLoan',
      monthlyPayment: 0,
      loanEndDate: '',
      subTypeClassification: '',
    })
  }, [getAccounts])

  function updateTSPLoanToSubmit(field, value) {
    tspLoanToSubmit[field] = value
    setTspLoanToSubmit(tspLoanToSubmit)
    updateIntakeStateAtKey({
      tspLoanToSubmit: tspLoanToSubmit,
    })
  }

  useEffect(() => {
    let loaded = false
    if (loaded) return

    storeTspLoans()
    loaded = true
  }, [getAccounts, storeTspLoans])

  const handleClose = useCallback(() => {
    setOpen(false)
    setName('')
    setAmount('')
    setMonthlyPayment('')
    setLoanEndDate('')
    setSortKey('')
    setSubTypeClassification('')
    setInterestRate('')
  }, [])

  const handleSubmit = useCallback(async () => {
    handleClose()
  }, [handleClose])

  const handleOpen = useCallback(() => {
    setModalTitle('Add A TSP Loan')
    setOpen(true)
  }, [])

  const handleViewAsset = useCallback(
    ({
      id,
      typeSubTypeUuid,
      _version,
      name,
      amount,
      subType,
      subTypeClassification,
      interestRate,
      loanEndDate,
      monthlyPayment,
    }) => {
      setType('liability')
      setId(id)
      setVersion(_version)
      setSortKey(typeSubTypeUuid)
      setName(name)
      setSubType('tspLoan')
      setAmount(amount)
      setOpen(true)
      setModalTitle(`Update ${name}`)
      setSubTypeClassification(subTypeClassification)
      setInterestRate(interestRate)
      setLoanEndDate(loanEndDate)
      setMonthlyPayment(monthlyPayment)
    },
    []
  )

  const BalanceSheetToStyle = ({ className }) => {
    return (
      <Grid className={className}>
        <BalanceSheetRow
          accounts={tspLoans}
          handleAddAccount={handleOpen}
          handleViewAccount={handleViewAsset}
          monthlyPayment={monthlyPayment}
          setMonthlyPayment={setMonthlyPayment}
          loanEndDate={loanEndDate}
          setLoanEndDate={setLoanEndDate}
          category={'tspLoan'}
          accountType={'Total TSP Loan Balance'}
          addAccountButtonText={`Add a TSP Loan`}
        />
      </Grid>
    )
  }
  const StyledDeductionsTable = styled(BalanceSheetToStyle)`
    .MuiAccordionSummary-root {
      padding: 0px;
      border-bottom: none;
    }
    .MuiAccordionSummary-root > .MuiAccordionSummary-content {
      margin: 0px;
    }
    .MuiAccordionSummary-root p {
      font-size: 24px !important;
      font-weight: 500;
    }
    .MuiAccordionDetails-root {
      background-color: #fff;
      padding-bottom: 0px;
      border-bottom: none;
    }
    .MuiAccordionDetails-root > div {
      border: 1px solid #ddd;
      border-radius: 8px;
    }
    .MuiAccordionDetails-root > div > div:last-of-type {
      border-bottom: none;
    }
    .MuiAccordionDetails-root > button {
      display: none;
      text-transform: capitalize;
      font-size: 16px;
      font-weight: normal;
      border: 1px solid rgb(221, 221, 221);
      border-radius: 8px;
      width: 100%;
      padding: 16px;
      margin-top: 20px;
    }
  `

  return (
    <>
      <BalanceSheetModalForm
        handleClose={handleClose}
        name={name}
        amount={amount}
        subType={subType}
        type={type}
        setName={setName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        open={open}
        handleSubmit={handleSubmit}
        reloadAccounts={storeTspLoans}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        modalHeader={'Edit this TSP Loan'}
      />
      {/* <BalanceSheetOnPageForm
        handleClose={handleClose}
        name={name}
        amount={amount}
        subType={subType}
        type={type}
        setName={setName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        open={open}
        handleSubmit={handleSubmit}
        reloadAccounts={storeTspLoans}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        componentHeader={'Tell us about any TSP loan(s) you have'}
        tspLoanToSubmit={tspLoanToSubmit}
        setTspLoanToSubmit={setTspLoanToSubmit}
        updateTSPLoanToSubmit={updateTSPLoanToSubmit}
      /> */}
      {/* <StyledDeductionsTable /> */}
      <Box sx={{ textAlign: 'left' }}>
        <Box mb={1}>
          <Typography variant="h4">
            Tell us about any TSP loan(s) you have
          </Typography>
        </Box>
        <Typography variant="body1">
          Your Loan information will help us with your financial planning
        </Typography>
        <Box pt={3}>
          <Grid container>
            <Grid item xs={12} mb={2}>
              <Grid item xs={12} mt={2} mb={2}>
                <Typography variant="body1Medium">
                  What type of TSP Loan is this?
                </Typography>
              </Grid>
              {renderMuiFormField({
                inputType: 'select',
                placeholder: 'TSP Loan Type',
                label: 'Loan Type',
                value: subTypeClassification,
                onChange: (value) => {
                  setSubTypeClassification(value)
                  updateTSPLoanToSubmit('subTypeClassification', value)
                },
                options: [
                  {
                    value: 'tspLoan-generalpurpose',
                    label: 'TSP Loan (General Purpose)',
                  },
                  {
                    value: 'tsploan-residential',
                    label: 'TSP Loan (Residential)',
                  },
                ],
              })}
            </Grid>
            <Grid item xs={12} mb={2}>
              <Grid item xs={12} mt={2} mb={2}>
                <Typography variant="body1Medium">
                  How much do you have remaining on this TSP Loan?
                </Typography>
              </Grid>
              {renderMuiFormField({
                inputType: 'currencyFloat',
                placeholder: '$15,000',
                label: 'Amount Remaining',
                value: amount,
                onChange: (value) => {
                  setAmount(value)
                  updateTSPLoanToSubmit('amount', value)
                },
              })}
            </Grid>
            <Grid item xs={12} mb={2}>
              <Grid item xs={12} mt={2} mb={2}>
                <Typography variant="body1Medium">
                  When Do You Estimate Your TSP Loan Will Be Paid Off?
                </Typography>
              </Grid>
              {renderMuiFormField({
                inputType: 'date',
                placeholder: '01/01/2030',
                label: 'Paid Off Date',
                value: loanEndDate,
                onChange: (value) => {
                  setLoanEndDate(value)
                  updateTSPLoanToSubmit('loanEndDate', value)
                },
              })}
            </Grid>
            <Grid item xs={12} mb={3}>
              <Grid item xs={12} mt={2} mb={2}>
                <Typography variant="body1Medium">
                  How Much Do You Pay Per Pay Period?
                </Typography>
              </Grid>
              {renderMuiFormField({
                inputType: 'currencyFloat',
                placeholder: '$150.00',
                label: 'Per Period Payment',
                value: monthlyPayment,
                onChange: (value) => {
                  setMonthlyPayment(value)
                  updateTSPLoanToSubmit('monthlyPayment', value)
                },
              })}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  )
}
